import React from "react";
import { Link, Routes, Route, Navigate, useLocation } from "react-router-dom";

import ProjectBody from "./projectBody";
import PublicationBody from "./publicationBody";
import ResearchInterest from "./researchInterest";
import BachelorThesisBody from "./BachelorThesisBody";
import MasterThesisBody from "./MasterThesisBody";

export default function Researchs() {
  const location = useLocation();

  const styles = {
    appBackground: {
      backgroundColor: "#000",
      minHeight: "100vh",
      color: "#f0f0f0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px",
    },
    container: {
      display: "flex",
      flexDirection: "row",
      maxWidth: "1700px",
      width: "150%",
      backgroundColor: "#111",
      borderRadius: "16px",
      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.7)",
      overflow: "hidden",
      padding: "5px",
    },
    tabList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
      display: "flex",
      flexDirection: "column",
      width: "30%",
      backgroundColor: "#222",
      borderRight: "1px solid #333",
    },
    tab: {
      padding: "15px",
      textDecoration: "none",
      fontSize: "16px",
      color: "#f0f0f0",
      borderRight: "3px solid transparent",
      display: "block",
    },
    activeTab: {
      backgroundColor: "#007bff",
      color: "#fff",
      borderRight: "3px solid #0056b3",
    },
    contentContainer: {
      padding: "5px",
      backgroundColor: "#000",
      flex: 1,
      borderRadius: "12px",
      boxShadow: "0 4px 8px rgba(255, 255, 255, 0.1)",
    },
  };

  const isActive = (path) => location.pathname.endsWith(path);

  return (
    <div style={styles.appBackground}>
      <div style={styles.container}>
        {/* Tabs with real links */}
        <ul style={styles.tabList}>
          <li>
            <Link
              to="interests"
              style={{
                ...styles.tab,
                ...(isActive("interests") ? styles.activeTab : {}),
              }}
            >
              Research Interests
            </Link>
          </li>
          <li>
            <Link
              to="projects"
              style={{
                ...styles.tab,
                ...(isActive("projects") ? styles.activeTab : {}),
              }}
            >
              Projects
            </Link>
          </li>
          <li>
            <Link
              to="publications"
              style={{
                ...styles.tab,
                ...(isActive("publications") ? styles.activeTab : {}),
              }}
            >
              Publications
            </Link>
          </li>
          <li>
            <Link
              to="bachelor-thesis"
              style={{
                ...styles.tab,
                ...(isActive("bachelor-thesis") ? styles.activeTab : {}),
              }}
            >
              Bachelor Thesis
            </Link>
          </li>
          <li>
            <Link
              to="master-thesis"
              style={{
                ...styles.tab,
                ...(isActive("master-thesis") ? styles.activeTab : {}),
              }}
            >
              Master Thesis
            </Link>
          </li>
        </ul>

        {/* Routed content */}
        <div style={styles.contentContainer}>
          <Routes>
            <Route path="/" element={<Navigate to="interests" />} />
            <Route path="interests" element={<ResearchInterest />} />
            <Route path="projects" element={<ProjectBody />} />
            <Route path="publications" element={<PublicationBody />} />
            <Route path="bachelor-thesis" element={<BachelorThesisBody />} />
            <Route path="master-thesis" element={<MasterThesisBody />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
